define('../app/fukit/collection/saveable.collection',['require','exports','module','underscore','datakit/datakit'],function(require, exports, module) {
  //prettier-ignore
  var _       = require('underscore'),
      DataKit = require('datakit/datakit');

  var SaveableCollection = DataKit.Model.Collection.extend({
    save: function(data, options) {
      return this.fetch(
        _.extend(
          {
            type: 'PUT',
            contentType: 'application/json',
            useAdapters: false,
            data: data ? JSON.stringify(data) : JSON.stringify(this),
            reset: true,
          },
          options
        )
      );
    },
  });

  module.exports = SaveableCollection;
});

